"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rgbToHex = rgbToHex;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.match");

function rgbToHex(rgb) {
  rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
  return rgb && rgb.length === 4 ? "#".concat("0".concat(parseInt(rgb[1], 10).toString(16)).slice(-2)).concat("0".concat(parseInt(rgb[2], 10).toString(16)).slice(-2)).concat("0".concat(parseInt(rgb[3], 10).toString(16)).slice(-2)) : '';
}